import { render, staticRenderFns } from "./Editable.vue?vue&type=template&id=18c5d19c&scoped=true"
import script from "./Editable.vue?vue&type=script&lang=js"
export * from "./Editable.vue?vue&type=script&lang=js"
import style0 from "./Editable.vue?vue&type=style&index=0&id=18c5d19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c5d19c",
  null
  
)

export default component.exports